import { useState } from "react";

import { DownOutlined } from "@ant-design/icons";
import { useTranslation } from "@impero-com/common/utils/i18n";
import { LinkButton } from "@impero-com/ui";
import { Checkbox, Dropdown, Space } from "antd";

import * as theme from "./ControlHealthAdjustView.css";
import { useControlHealthWidgets } from "./useControlHealthWidgets";

type Props = Pick<
    ReturnType<typeof useControlHealthWidgets>,
    "widgets" | "setVisible"
>;

export function ControlHealthAdjustView({ widgets, setVisible }: Props) {
    const { t } = useTranslation();
    const [open, setOpen] = useState(false);

    return (
        <Dropdown
            open={open}
            onOpenChange={setOpen}
            trigger={["click"]}
            placement="bottomRight"
            dropdownRender={() => (
                <div className={theme.dropdown}>
                    <div className={theme.title}>
                        {t("ControlHealth_Widgets")}
                    </div>
                    {widgets.map((widget) => (
                        <Checkbox
                            className={theme.item}
                            key={widget.id}
                            checked={widget.visible}
                            onChange={(event) =>
                                setVisible(widget.id, event.target.checked)
                            }
                        >
                            {widget.label}
                        </Checkbox>
                    ))}
                </div>
            )}
        >
            <LinkButton aria-expanded={open}>
                <Space>
                    {t("ControlHealth_AdjustView")} <DownOutlined />
                </Space>
            </LinkButton>
        </Dropdown>
    );
}
